import { useQuery } from '@tanstack/react-query';
import { checkMerchantOrBCAPI } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { QUERY_KEYS } from './QueryKeys';

export const useMerchantCheck = (onModalShow) => {
    const agentid = localStorage.getItem('id');
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');

    return useQuery({
        queryKey: QUERY_KEYS.MERCHANT_CHECK(agentid),
        queryFn: async () => {
            const payloadCheck = { agentid };
            const response = await checkMerchantOrBCAPI(payloadCheck);
            return {
                agentType: response?.data?.agentType,
                isPending: response?.data?.isPending,
                shouldShowModal: response?.data?.agentType === 'Merchant' || response?.data?.isPending || shouldshowEsign === 'true'
            };
        },
        staleTime: 60000,
        onSuccess: (data) => {
            if (data?.shouldShowModal) {
                onModalShow(true);
            }
        }
    });
};
